import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { TicketBatch } from '../entities/ticket-batch';

export class TicketBatchRequest extends BaseRequest{

	constructor(userInfo : UserInfo){    
		super(userInfo)
	}
	
	ticketBatch : TicketBatch;
}